import { memo } from 'react';

import { WorkspaceSidebarCanvasesListItem } from '~/components/v2/components/workspace/workspace-sidebar/WorkspaceSidebarCanvasesListItem';
import { type CanvasListItem } from '~/swr-hooks/canvases/types';

export type WorkspaceSidebarCanvasesListProps = {
  canvases: CanvasListItem[];
  selectedCanvasId: string | null | undefined;
  onSelect: (canvasId: string) => void;
};

export const WorkspaceSidebarCanvasesList = memo(
  ({ canvases, selectedCanvasId, onSelect }: WorkspaceSidebarCanvasesListProps) => {
    return (
      <>
        {canvases.map((canvas) => (
          <WorkspaceSidebarCanvasesListItem
            key={canvas.id}
            canvas={canvas}
            isActive={selectedCanvasId === canvas.id}
            onSelect={onSelect}
          />
        ))}
      </>
    );
  },
);

WorkspaceSidebarCanvasesList.displayName = 'WorkspaceSidebarCanvasesList';
